import { isValidPhoneNumber } from 'react-phone-number-input';

const validatePhoneNumberWithCountrySelect = (phoneNumber) => isValidPhoneNumber(phoneNumber);

export default validatePhoneNumberWithCountrySelect;
